/* fj-rewriter.js — injeta o nome do time/clube no browser do cliente.
   O servidor (Shopify) só conhece o CÓDIGO numérico; este script busca o mapa
   no Cloudflare Worker e reescreve os títulos visíveis (H1, cards, carrinho).
   Sem nomes hardcoded aqui — apenas lógica + URL do worker. */
(function () {
  "use strict";
  var WORKER = "https://fj-name-rewriter.footjersey.workers.dev";
  var CACHE_KEY = "fj_team_map_v1";
  var TTL_MS = 6 * 3600 * 1000; /* 6h */

  function getCached() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.map || Date.now() - o.ts > TTL_MS) return null;
      return o.map;
    } catch (e) { return null; }
  }
  function setCached(map) {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), map: map })); } catch (e) {}
  }
  function fetchMap() {
    return fetch(WORKER + "/api/all-teams", { credentials: "omit", cache: "default" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (j && Object.keys(j).length) { setCached(j); return j; }
        return null;
      })
      .catch(function () { return null; });
  }

  function nameFor(code, map) {
    if (!code || !map) return null;
    var t = map[code];
    return t && t.name ? t.name : null;
  }

  function prefixTitle(el, teamName) {
    /* NAO escrever em el.textContent quando o elemento contem um link:
       isso apaga o <a> e o produto/card deixa de ser clicavel.
       Escreve no <a> interno (ou no proprio elemento, se nao houver link). */
    var target = el.querySelector("a") || el;
    var orig = (target.textContent || "").replace(/^\s+|\s+$/g, "");
    if (!orig) return;
    if (orig.indexOf(teamName) === 0) return;
    var first = orig.split(" ")[0];
    var teamFirst = teamName.split(" ")[0];
    if (first && teamFirst && first === teamFirst) return; /* já tem ao menos a 1ª palavra */
    target.textContent = teamName + " " + orig;
  }

  function rewriteAll(map) {
    var els = document.querySelectorAll("[data-fj-team-code]:not([data-fj-done])");
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var code = el.getAttribute("data-fj-team-code");
      var name = nameFor(code, map);
      if (!name) { el.setAttribute("data-fj-done", "no-team"); continue; }
      if (el.tagName === "H1" || el.tagName === "H2" || el.tagName === "H3") {
        prefixTitle(el, name);
      } else {
        prefixTitle(el, name);
      }
      el.setAttribute("data-fj-done", "1");
    }
    /* title da aba (PDP): prefixa o nome quando o H1 tiver código */
    var h1 = document.querySelector("h1[data-fj-team-code]");
    if (h1 && h1.getAttribute("data-fj-done") === "1") {
      var code = h1.getAttribute("data-fj-team-code");
      var name = nameFor(code, map);
      if (name && document.title && document.title.indexOf(name) === -1) {
        document.title = name + " " + document.title;
      }
    }
  }

  function boot() {
    var cached = getCached();
    if (cached) {
      rewriteAll(cached);
      fetchMap().then(function (m) { if (m) rewriteAll(m); });
    } else {
      fetchMap().then(rewriteAll);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  /* cards dinâmicos (load more, ajax, busca) */
  if ("MutationObserver" in window) {
    var deb;
    var obs = new MutationObserver(function () {
      clearTimeout(deb);
      deb = setTimeout(function () {
        var m = getCached();
        if (m) rewriteAll(m);
      }, 250);
    });
    obs.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();
